import { useCallback, useEffect, useState } from 'react';

/** Copies text to the clipboard; `copied` flips true for a moment. Fails silently when blocked. */
export function useCopy(resetMs = 2000): { copied: boolean; copy: (text: string) => void } {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = window.setTimeout(() => setCopied(false), resetMs);
    return () => window.clearTimeout(timer);
  }, [copied, resetMs]);

  const copy = useCallback((text: string) => {
    try {
      void navigator.clipboard
        ?.writeText(text)
        .then(() => setCopied(true))
        .catch(() => undefined);
    } catch {
      // Clipboard unavailable (insecure context, permissions): nothing to do.
    }
  }, []);

  return { copied, copy };
}
